import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Typography from '@material-ui/core/Typography'; 
import FacultyMember from './FacultyMembers/FacultyMember';
//import Guest from './FacultyMembers/Guest';
import Researcher from './FacultyMembers/Researcher';
import Postdoc from './FacultyMembers/Postdoc';
import PhDstudent from './FacultyMembers/PhDstudent';
import Pastmember from './FacultyMembers/Pastmember';
import Maurice from './Maurice2.jpg';
import Felix  from './Felix2.jpg';
import Kurt  from './Kurt.jpg';
import Kevin from './Kevin2.jpg';
//import Gernot from './Gernot.jpg';
import Diane from './Diane.jpeg';

import Gaultier from './Gaultier2.jpg';
import YuanYuan from './Yuanyuan_Xu.jpg';

import Tomas from './Tomas.JPG';
import Clara from './Klara.jpg';
import Philippe from './Philippe2.jpg';
import Scott from './Scott.jpg';
import Wenkui from './Wenkui2.jpg';
import Bao from './Bao2.png';
import Erik from './Erik.jpg';
import Nedialko from './Nedialko.jpg';
import Benjamin from './Fahs2.jpg';
import Ahmad from './Barhoumi.jpg';
import Nathan from './Nathan.png';
import Roger from './Roger.jpeg';




const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width:'75%',
    align:'center'
  },
  root:{
    marginTop:70
},
  
  item:
  {
      width:'33.3%',
      minWidth:100
  },
  h:
  {
      margin:'5%',
      color:'#009688',
      paddingBottom:20,
      borderBottom: 'solid 0.02em',
      width:'60%',
      marginBottom:40
  },
  imag:
    {  
        fit: 'contain',
        maxHeight:'75%',
        maxWidth:'60%',
        flexShrink: 1,
        margin:'auto'
    }
}));






export default function Members() {
  const classes = useStyles();
  const [spacing]=React.useState(2);
  
  return (
      <div align="center" style={{width:'80%', margin:'7%'}}>
          <Typography  variant="h4" className={classes.h}>
                    Faculty Members
            </Typography>
            
        <Grid container alignItems="center" justify="center"  spacing={spacing} style={{marginBottom:0}}>
        
            <FacultyMember name={Maurice} 
                            fullName="Maurice Duits"
                            webpage="https://people.kth.se/~duits">
            </FacultyMember>
            <FacultyMember name={Kurt} 
                            fullName="Kurt Johansson"
                            webpage="https://people.kth.se/~kurtj">
             </FacultyMember>
        </Grid>
        <Grid container alignItems="center" justify="center"  spacing={spacing} style={{marginBottom:100}}>
         <FacultyMember name={Gaultier} 
                        fullName="Gaultier Lambert"
                        webpage="https://people.kth.se/">
         </FacultyMember>
        <FacultyMember name={Kevin} 
                        fullName="Kevin Schnelli"
                        webpage="https://people.kth.se/~schnelli"
        ></FacultyMember>
    </Grid>
 
        
     

    
   
    <Typography variant="h4" className={classes.h} >
                    Researchers
    </Typography>
   
    <Grid container justify="center" spacing={spacing} style={{marginBottom:100}}>    
    
        
        
        <Researcher 
            name={Erik}
            fullName="Erik Duse" 
            startdate="September, 2019"
            webpage="https://people.kth.se/~duse">
        </Researcher>
        <Researcher 
            name={Diane} 
            fullName="Diane Holcomb" 
            startdate="September, 2019"
            webpage="https://people.kth.se/~holcomb">
        </Researcher>

        <Researcher 
            name={Bao} 
            fullName="Bao Nguyen" 
            startdate="Feburary, 2020"
            webpage="https://sites.google.com/site/baohomepage/">
        </Researcher>
           
    </Grid>
    
    <Typography variant="h4" className={classes.h} >
                    Postdocs
            </Typography>
        <Grid container justify="center" spacing={spacing} style={{marginBottom:100}}>
       
        <Postdoc 
                name={Ahmad}
                fullName="Ahmad Barhoumi" 
                startdate="September, 2023"
                webpage="https://ahmadbarhoumi.com/"/>
                   <Postdoc 
                name={Nathan}
                fullName="Nathan Hayford" 
                startdate="September, 2023"
                webpage="https://sites.google.com/view/nathanhayford"></Postdoc>
 <Postdoc 
                name={Roger}
                fullName="Roger Van Peski" 
                startdate="September, 2023"
                webpage="https://math.mit.edu/~rvp/"></Postdoc>
                <Postdoc 
                name={Benjamin}
                fullName="Benjamin Fahs" 
                startdate="September, 2021"
                webpage=""/>
                <Postdoc 
               name={Felix}
                fullName="Felix Parraud" 
                startdate="September, 2021"
                webpage="https://fparr.github.io/"/>
    
    </Grid>

   

    <Typography variant="h4" className={classes.h}>
                    PhD Students
    </Typography>
    <Grid container justify="center" spacing={spacing} style={{marginBottom:100}}>
    <PhDstudent 
                    name={Nedialko} 
                   fullName="Nedialko Bradinoff" 
                   advisor="Maurice Duits"
                   startdate= "September 2021"
                   webpage="https://www.kth.se/profile/nedialko"
                />
        
             
             <PhDstudent 
                    name={Wenkui} 
                   fullName="Wenkui Liu" 
                   advisor="Maurice Duits"
                   startdate= "September 2019"
                   webpage=""
                />      
                   
        </Grid>

        <Typography variant="h4" className={classes.h}>
                    Past Members
    </Typography>
    <Grid container justify="center" spacing={spacing}>
        

   
    <Pastmember 
                fullName="Klara Courteaut"
                position="PhD" 
                period=" 2018/2023"
                after="After: Courant Institute"/>
                
    <Pastmember 
                fullName="Scott Mason"
                position="PhD" 
                period=" 2017/2022"
                after="After: Cambridge University"/>
                  <Pastmember 
                fullName="Phillipe Moreillon"
                position="PhD" ç
                period=" 2017/2022"
                after="After: University of Geneva"/>

         <Pastmember 
                fullName="Elnur Emrah"
                position="Postdoc" 
                period=" 2019/2022"
                webpage="https://sites.google.com/view/elnur-emrah"
                after="After: University of Bristol"/>
    <Pastmember 
                name={YuanYuan} 
                fullName="Yuanyuan Xu"
                position="Postdoc" 
                period=" 2018/2021"
                webpage=""
                after="After: IST Austria"/>
                
    <Pastmember 
                    name={Tomas} 
                   fullName="Tomas Berggren" 
                   position="PhD student"
                   period= "2015/2020"
                   after="After: Michigan (Ann-Arbor)"
                />
             <Pastmember 
                   fullName="Mustazee Rahman" 
                   position="Postdoc"
                   period= "2018/2019"
                  after="After: Durham University"
                />
            <Pastmember
                   fullName="Yuchen Pei" 
                   period= "2017/2019"
                   position="Postdoc"
                   after="After: Google Zürich"
                />
                  
                 <Pastmember
                   fullName="Yting Li" 
                   position="Postdoc"
                   period= "2017/2019"
                   after="After: Marseille"
                />   
                 
        </Grid>

        <Typography variant="h4" className={classes.h} >
                    Former KAW Guest Professors
    </Typography>
    
    <Grid container justify="center" spacing={spacing} style={{marginBottom:100}}>
                <Pastmember 
                        fullName="Gernot Akemann" 
                        period="Sept 1 - Nov 31, 2019"
                        after="Bielefeld University"
                        webpage='https://www2.physik.uni-bielefeld.de/akemann-contact.html'>
                </Pastmember>

                <Pastmember 
                        fullName="Arno Kuijlaars" 
                        period="February 1 - June 30, 2017"
                        after="KULeuven"
                        webpage='https://perswww.kuleuven.be/~u0017946/'>
                </Pastmember>

              
                </Grid>
    </div>
  );
}